type SlugPart = string | null | undefined;

function makeSlug(slug: SlugPart): string;
function makeSlug(...slugs: SlugPart[]): string;
function makeSlug(...slugs: SlugPart[]): string {
  // Only join string parts. Array.map(makeSlug) also passes index and array,
  // which the unary overload hides from TypeScript but still arrive at runtime.
  const slugString = slugs
    .filter((slug): slug is string => typeof slug === "string")
    .map((slug) => removeDoubleSlashes(makeSlugString(slug)))
    .join("");

  // Fall back to the root slug when every argument is null/undefined, matching
  // the previous single-arg makeSlug contract. Callers like the Elevate
  // landingPage query pass an optional pageReference and rely on "/" (a valid
  // root reference) rather than "" (rejected as a missing parameter).
  return removeDoubleSlashes(slugString) || "/";
}

function makeSlugString(slug: string) {
  return slug.startsWith("/") ? slug : `/${slug}`;
}

function removeDoubleSlashes(slug: string) {
  let result = slug;
  while (result.includes("//")) {
    result = result.replaceAll("//", "/");
  }
  return result;
}

export default makeSlug;
